// Upload a File straight to Vercel Blob from the browser. Two hops, plain fetch
// (no SDK — its server/webhook code drags undici+jose into the bundle): ask our
// route for a scoped, single-file client token, then PUT the bytes to the Blob
// API with that token. The store's read-write secret never reaches the browser.
//
// This keeps big files out of the JSON form posts, which go through Vercel
// functions with a ~4.5 MB request-body ceiling.

const BLOB_API = 'https://blob.vercel-storage.com';

/** Folders /api/blob-upload-token will sign for — each has its own type/size policy. */
export type BlobFolder = 'it-tickets' | 'marketing';

export type UploadedBlob = { name: string; type: string; size: number; url: string };

export async function uploadToBlob(
  file: File,
  folder: BlobFolder,
  accessToken: string | undefined,
): Promise<UploadedBlob> {
  const type = file.type || 'application/octet-stream';
  const pathname = `${folder}/${file.name}`;

  const tokenRes = await fetch('/api/blob-upload-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: JSON.stringify({ type: 'blob.generate-client-token', payload: { pathname } }),
  });
  if (!tokenRes.ok) throw new Error('Could not authorize the upload');
  const { clientToken } = (await tokenRes.json()) as { clientToken?: string };
  if (!clientToken) throw new Error('Could not authorize the upload');

  // Only send CORS-allowed headers. addRandomSuffix / allowedContentTypes /
  // max size are baked into the client token by the server, NOT sent as
  // headers — the browser preflight rejects x-add-random-suffix.
  const putRes = await fetch(`${BLOB_API}/${pathname}`, {
    method: 'PUT',
    headers: {
      authorization: `Bearer ${clientToken}`,
      'x-content-type': type,
    },
    body: file,
  });
  if (!putRes.ok) throw new Error(`Upload failed (${putRes.status})`);
  const blob = (await putRes.json()) as { url: string };
  return { name: file.name, type, size: file.size, url: blob.url };
}
